// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.Message
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { MessageSeverityType } from "abweb/dto/generated/MessageSeverityType";
export class MessageBase {
  /** Do NOT invoke directly, instead use strongly typed createMessageBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawad.Message";
  }
  initFromJson(json, deserializeContext) {
    this.initMessage(json.html != null ? json.html : null, json.severity != null ? MessageSeverityType.fromJson(json.severity) : null, json.text != null ? json.text : null);
  }
  initMessage(html, severity, text) {
    this._html = html;
    this._severity = severity;
    this._text = text;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["html"] = this._html;
    retVal["severity"] = this._severity;
    retVal["text"] = this._text;
    return retVal;
  }
  get html() {
    return this._html;
  }
  set html(value) {
    this._html = value;
  }
  get severity() {
    return this._severity;
  }
  set severity(value) {
    this._severity = value;
  }
  get text() {
    return this._text;
  }
  set text(value) {
    this._text = value;
  }
}
//# sourceMappingURL=MessageBase.js.map
